<template>
    <div id="templatePane">
        <div class="hero-section shade-40">
            <div class="hero-section-text row column">
                <h1>How To fix Multi Factor Authentication issues</h1>
            </div>
        </div>
        <section id="mainContent" class="row column">
            <p>Some Microsoft applications such as Workplace by Facebook and Office 365 use ​Multi Factor Authentication (MFA) for security verification during the setup process. If you're having issues with MFA and need to change the phone number being used, follow these steps:</p>
            <ol>
                <li>Go to <a target="_blank" href="https://account.activedirectory.windowsazure.com/r#/applications">https://account.activedirectory.windowsazure.com/r#/applications</a>
                <li>Click your <strong>name</strong> in the top right then click <strong>Profile</strong>.
                <p><img src="/static/images/help/25862-1.png" alt="" /></p></li>
                <li>Click <strong>Additional security verification</strong>. You'll now receive a call on the number currently registered for MFA, answer the call, follow the instructions then go to step 4. <br>
                <strong>Note:</strong> If you don't receive a call it could be calling a number you no longer have access to, in this case please contact your Service Desk using the links at the bottom of this article.
                <p><img src="/static/images/help/25862-3.png" alt="" /></p></li>
                <li>Change the 'Authentication phone' number to your number shown on <a target="_blank" href="http://directory.intra.bt.com/">Directory</a>. Click <strong>Save</strong>.
                <p><img src="/static/images/help/25862-4.png" alt="" /></p></li>
                <li>You'll now be called by a Microsoft automation system to verify you're the registered owner of the phone. Answer the call and you'll be asked to press <strong>#</strong> to confirm.</li>
            </ol>
            <p>If the above steps don’t fix your issue please contact the Service Desk.</p>
            <p>Need more help?  Browse our <a href="/help">list of articles.</a></p>
        </section>
    </div>
</template>
<script>
    export default {
    name: 'Help25862'
}
</script>